<template>
  <div class="page-container">
    <div class="settings-form">
      <h2 class="page-title">邮件测试记录</h2>

      <!-- 搜索区域 -->
      <div class="search-bar">
        <el-input v-model="searchForm.keyword" placeholder="请输入收件人邮箱或名称" clearable size="large"
          style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>

        <el-button type="primary" size="large" @click="handleSearch">
          <el-icon>
            <Search />
          </el-icon>
          搜索
        </el-button>

        <el-button type="danger" size="large" @click="handleClearAll" style="float: right" :disabled="recordList.length === 0">
          <el-icon>
            <Delete />
          </el-icon>
          清空记录
        </el-button>
      </div>

      <!-- 测试记录列表 -->
      <el-table :data="recordList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="account_name" label="邮箱账户" width="150" />
        <el-table-column prop="template_name" label="邮件模板" width="150" />
        <el-table-column prop="test_type" label="测试类型" width="100">
          <template #default="{ row }">
            <el-tag :type="row.test_type === 'account' ? 'primary' : 'success'">
              {{ row.test_type === 'account' ? '账户测试' : '模板测试' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="receiver_name" label="收件人名称" width="120" />
        <el-table-column prop="receiver_email" label="收件人邮箱" width="200" />
        <el-table-column prop="subject" label="邮件主题" width="200" />
        <el-table-column prop="content" label="邮件内容">
          <template #default="{ row }">
            <div class="content-preview">{{ row.content }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="send_status" label="发送状态" width="100" align="center">
          <template #default="{ row }">
            <el-tag :type="row.send_status === 1 ? 'success' : 'danger'">
              {{ row.send_status === 1 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="error_message" label="错误信息" width="200">
          <template #default="{ row }">
            <span v-if="row.error_message" class="error-message">{{ row.error_message }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="测试时间" width="180" />

        <el-table-column label="操作" width="120" fixed="right">
          <template #default="scope">
            <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
              <el-icon>
                <Delete />
              </el-icon>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
          :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
          @size-change="fetchRecordList" @current-change="fetchRecordList" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import {
  Search, Delete
} from '@element-plus/icons-vue'

export default {
  name: 'EmailTestRecord',
  components: { Search, Delete },
  data() {
    return {
      loading: false,
      searchForm: {
        keyword: ''
      },
      recordList: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('pc_user_info') || '{}')
    }
  },
  mounted() {
    this.fetchRecordList();
  },
  methods: {
    // 获取测试记录列表
    async fetchRecordList() {
      this.loading = true;
      try {
        const params = {
          action: 'list',
          store_id: this.userInfo.store_id,
          user_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        };

        const { data } = await axios.post(
          `${config.BASE_URL}/pc/api/email_test_record.php`,
          params
        );

        if (data.data) {
          this.recordList = data.data;
          this.pagination.total = data.pagination?.total || data.data.length;
        }
      } catch (error) {
        this.$message.error('获取测试记录列表失败');
        console.error('获取测试记录列表错误:', error);
      } finally {
        this.loading = false;
      }
    },

    // 处理搜索
    handleSearch() {
      this.pagination.page = 1;
      this.fetchRecordList();
    },

    // 删除记录
    async handleDelete(id) {
      this.$confirm('确定要删除该测试记录吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/pc/api/email_test_record.php`,
            {
              action: 'delete',
              id: id,
              store_id: this.userInfo.store_id,
              user_id: this.userInfo.id
            }
          );

          if (data.success) {
            this.$message.success('删除成功');
            this.fetchRecordList();
          } else {
            this.$message.error(data.error || '删除失败');
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '删除失败';
          this.$message.error(`删除失败: ${errorMsg}`);
          console.error('删除错误:', error);
        }
      }).catch(() => { });
    },

    // 清空所有记录
    async handleClearAll() {
      this.$confirm('确定要清空所有测试记录吗？此操作不可恢复！', '警告', {
        confirmButtonText: '确认清空',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      }).then(async () => {
        this.loading = true;
        try {
          // 批量删除所有记录
          const deletePromises = this.recordList.map(record => 
            axios.post(`${config.BASE_URL}/pc/api/email_test_record.php`, {
              action: 'delete',
              id: record.id,
              store_id: this.userInfo.store_id,
              user_id: this.userInfo.id
            })
          );
          
          await Promise.all(deletePromises);
          this.$message.success('清空成功');
          this.fetchRecordList();
        } catch (error) {
          this.$message.error('清空失败');
          console.error('清空错误:', error);
        } finally {
          this.loading = false;
        }
      }).catch(() => { });
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding: 0px;
}

.settings-form {
  max-width: 95%;
  margin: 0 auto;
  padding: 32px 40px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.page-title {
  font-size: 24px;
  color: #1f2937;
  margin-bottom: 32px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.5px;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
}

.pagination-container {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.content-preview {
  max-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-height: 1.4;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
}

/* 表格样式优化 */
.el-table {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;

  :deep(.el-table__header) th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
  }

  :deep(.el-table__body) tr:hover>td {
    background-color: #f0f7ff !important;
  }
}

/* 操作按钮样式 */
.el-button {
  display: inline-flex;
  align-items: center;

  .el-icon {
    margin-right: 5px;
  }
}
</style>